import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const ScoreWrapper = styled.div`
  grid-area: score;
  align-items: flex-end;
  justify-content: center;
  display: flex;
  flex-direction: row;
  margin: 0 15px 0 0;
  
  .CircularProgressbar .CircularProgressbar-path {
    stroke: ${(props) => props.color};
  }
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0;
    height: 160px;
  }
  
`;

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  width: 100%;
  
  @media (min-width: ${breakpoints.desktop}) {
    flex-direction: row;
  }
`;

export const ScoreCircleWrapper = styled.div`
  width: 50%;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (min-width: ${breakpoints.desktop}) {
    cursor: pointer;
  }
`;

export const ScoreCircle = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto 15px auto;
  justify-content: center;
  align-items: center;
  align-self: center;
  
  @media (min-width: ${breakpoints.desktop}) {
    width: 140px;
    height: 140px;
  }
`;

export const ScoreCircleText = styled.p`
  color: white;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  margin-top: -45px;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin-top: -50px;
  }
`;

export const MileageOuterWrapper = styled.div`
  
`

export const MileageWrapper = styled.div`
  flex-direction: column;
    flex: 1;
    margin: 15px 0 0 0px;
    width: 80%;
    
  @media (min-width: ${breakpoints.desktop}) {
  margin: 15px 0 0 15px;
  cursor: pointer;
  }
`;

export const MileageCharacters = styled.div`
  margin: 0px auto 5px auto;
  align-self: center;
  flex-direction: row;
  justify-content: center;
  display: flex;
`;

export const MileageItem = styled.span`
  color: black;
  background:linear-gradient(#ffffff,#a3a3a3);
  padding: 3px;
  font-size: 1.7rem;
  margin: 1px;
  font-weight: bold;
  min-width: 23px;
  
  @media (min-width: ${breakpoints.desktop}) {
    font-size: 1.7rem;
    border: 2px #707070 solid;
  }
  
`;

export const MileageLabel = styled.p`
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 10px 0;
  }
`;

export const MileageInput = styled.input`
  font-size: 2rem;
  border: 0;
  width: 210px;
  text-align: center;
  background-color: lightgray;
`;

export const TMUWrapper = styled.div`
  flex-direction: row;
  width: 50%;
  margin: 10px 0 0 0;
  background-color: #545353;
  padding: 5px;

  @media (min-width: ${breakpoints.desktop}) {
    margin: 15px 0 0 15px;
  }
`;

export const TMURow = styled.div`
  margin: 5px 0;
`;

export const TMULabel = styled.label`

`;
